module.exports = __webpack_public_path__ + "img/career-history.ee6f5620.svg";